import React from "react";
import { useFormikContext } from "formik";
import { Grid, TextField, Typography, Switch, FormControlLabel, Box, Autocomplete } from "@mui/material";
import { entities } from "helpers/changeOptions";

const labelTextStyle = {
  fontSize: "13px",
  fontWeight: 500,
  fontFamily: "Outfit, sans-serif",
  color: "#0A0A0C",
  mb: 0.5,
};

const errStyle = { color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" };

export default function WorkflowHeaderForm() {
  const { values, handleChange, handleBlur, touched, errors, setFieldValue, setFieldTouched } = useFormikContext();

  const fieldSx = { width: "100%", maxWidth: "100%" };

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid size={{ md: 4, xs: 12 }}>
        <Typography sx={labelTextStyle}>Workflow Name</Typography>
        <TextField
          fullWidth
          sx={fieldSx}
          name="workflowName"
          value={values.workflowName || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Enter workflow name"
        />
        {touched.workflowName && errors.workflowName && <Typography sx={errStyle}>{errors.workflowName}</Typography>}
      </Grid>

      <Grid size={{ md: 4, xs: 12 }}>
        <Typography sx={labelTextStyle}>Entity Name</Typography>
        <Autocomplete
          options={entities}
          getOptionLabel={(option) => option?.label || ''}
          value={
            entities?.find(
              (opt) => opt.label === values?.entityName
            ) || null
          }
          onChange={(_, newSelected) => {
            setFieldValue(
              "entityName",
              newSelected ? newSelected.label : ""
            );
          }}
          onBlur={() => setFieldTouched("entityName", true)}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Entity Name"
              name="status"
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "100%",
                  letterSpacing: "0.16px",
                  color: "#0A0A0C",
                  fontFamily: "Outfit, sans-serif",
                },
                "& input::placeholder": {
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "100%",
                  letterSpacing: "0.16px",
                  color: "#5F5F5F",
                  fontFamily: "Outfit, sans-serif",
                  opacity: 1,
                },
              }}
            />
          )}
          ListboxProps={{ sx: { fontSize: '13px' } }}
        />
        {/* <TextField
          fullWidth
          sx={fieldSx}
          name="entityName"
          value={values.entityName || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Enter entity name"
        /> */}
        {touched.entityName && errors.entityName && <Typography sx={errStyle}>{errors.entityName}</Typography>}
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <Typography sx={labelTextStyle}>Description</Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          sx={fieldSx}
          name="description"
          value={values.description || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Enter workflow description"
        />
        {touched.description && errors.description && <Typography sx={errStyle}>{errors.description}</Typography>}
      </Grid>

      <Grid size={{ md: 12, xs: 12 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <FormControlLabel
            control={<Switch checked={!!values.isActive} name="isActive" onChange={handleChange} />}
            label={values.isActive ? "Active" : "Inactive"}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
